const drawerHeaderContentTokens = ({ borders, colors }) => ({
  borders: {
    top: borders[0],
    bottom: `${borders[1]} ${colors.neutrals[5]}`,
  },
  colors: colors.white,
});

export default drawerHeaderContentTokens;
